import filtersDisplayConfig from "./filtersDisplay.config";
import apiPathsConfig from './apiPaths.config';
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";

import AssetTypesMapping from '@/data/mappings/AssetTypes.map';

const resultsManipulationCallback = (resultItem) => {
  resultItem.assetType = AssetTypesMapping[resultItem.assetType];
}

const itemsListerConfig = {
  apiPathsConfig,
  resultsManipulationCallback,
  filtersDisplayConfig,
  availableActionsConfig,
  availableListViewsConfig,
}

export default itemsListerConfig;